import { isAuthorized } from 'utils/Auth'
import { createReducer } from '../../utils'

export const TASK_REQUEST = 'sherrinford/TaskList/list/TASK_REQUEST'
export const TASK_SUCCESS = 'sherrinford/TaskList/list/TASK_SUCCESS'
export const TASK_ERROR = 'sherrinford/TaskList/list/TASK_ERROR'

export const TASK_STATUS = 'sherrinford/TaskList/list/TASK_STATUS'
export const SELECTED_TASK_STATUS = 'sherrinford/TaskList/list/SELECT_TASK_STATUS'

export const SEARCH_PROJECT_NAME = 'sherrinford/TaskList/list/SEARCH_PROJECT_NAME'

export const IS_LOADING = 'sherrinford/TaskList/list/IS_LOADING'
export const TASK_DATA = 'sherrinford/TaskList/list/DATA'
export const PROJECT_DATA = 'sherrinford/TaskList/list/PROJECT_DATA'

export const SET_CURRENTPAGE = 'sherrinford/TaskList/list/SET_CURRENTPAGE'
export const RESET_CURRENTPAGE = 'sherrinford/TaskList/list/RESET_CURRENTPAGE'
export const SAVE_CURRENTPAGE = 'sherrinford/TaskList/list/SAVE_CURRENTPAGE'

const initialState = {
  taskData: {
    count: 0,
    currentPage: 1,
    totalPages: 0,
    rows: [],
    qs: {
      skip: 0,
      limit: 10,
      sort: '',
    },
  },

  isLoading: false,
  isError: false,
  errorMessage: '',

  taskStatus: '',
  selectedTaskStatus: '',
  searchProjectName: '',

  taskStatusList: {
    notStarted: {
      status: 0,
      label: 'Not Started',
    },
    inProgress: {
      status: 1,
      label: 'In Progress',
    },
    completed: {
      status: 2,
      label: 'Completed',
    },
  },
}

export default createReducer(initialState, {
  [TASK_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [TASK_STATUS]: (state, data) => ({
    ...state,
    taskStatus: data,
  }),
  [SELECTED_TASK_STATUS]: (state, data) => ({
    ...state,
    selectedTaskStatus: data,
  }),

  [TASK_SUCCESS]: (state, taskData) => ({
    ...state,
    taskData,
    isLoading: false,
  }),
  [TASK_ERROR]: (state, data) => ({
    ...state,
    isError: true,
    errorMessage: data.message,
    isLoading: false,
  }),
  [SEARCH_PROJECT_NAME]: (state, data) => ({
    ...state,
    searchProjectName: data,
  }),

  [IS_LOADING]: (state, data) => ({
    ...state,
    isLoading: data,
  }),

  [PROJECT_DATA]: (state, projectData) => ({
    ...state,
    projectData,
  }),
  [TASK_DATA]: (state, taskData) => ({
    ...state,
    taskData,
  }),
})

export const setTaskStatusList = data => ({
  type: [TASK_STATUS],
  payload: data,
})

export const setSelectedTaskStatus = data => ({
  type: [SELECTED_TASK_STATUS],
  payload: data,
})

export const projectInput = data => ({
  type: [SEARCH_PROJECT_NAME],
  payload: data,
})

export const getTaskWithFilter = (qs, cb = () => {}) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      TASK_REQUEST,
      TASK_SUCCESS,
      TASK_ERROR,
    ],
    shuttle: {
      method: 'GET',
      path: '/task/by_order_profile',
      authorization: `${token}`,
      qs,
    },
    nextAction: (res) => {
      cb(res)
    },
  }
}

export const getTasks = (qs, cb = () => {}) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      TASK_REQUEST,
      TASK_SUCCESS,
      TASK_ERROR,
    ],
    shuttle: {
      method: 'GET',
      path: '/task',
      authorization: `${token}`,
      qs,
    },
    nextAction: (res) => {
      cb(res)
    },
  }
}

export const setProjectData = data => ({
  type: [PROJECT_DATA],
  payload: data,
})

export const setTaskData = data => ({
  type: [TASK_DATA],
  payload: data,
})


export const setLoadState = data => ({
  type: [IS_LOADING],
  payload: data,
})
